<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Bullhorn" class="d-icon d-icon--bullhorn" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2Z" fill="#F76834"/><path d="M3 6.961c0 .215.135.996 2.89 1.13-.083.35-.239.677-.458.96a1.175 1.175 0 0 0 .376 1.589 16.34 16.34 0 0 0 2.001-.162c1.176.467 2.414 2.782 2.692 2.97 1.032 1.211 3.59 1.283 3.59 1.283a.539.539 0 0 1 .493.512c.077.345.259.658.52.897 0 0 .314 0 .512.619.197.62 1.247.547 1.247.547s.897-.628 0-1.067h-.135a.69.69 0 0 1-.395-.153 1.041 1.041 0 0 0-.34-.61c-.144-.305.26-.503.26-.503l.79-.502a.314.314 0 0 0 .152-.251c.005-.367.038-.733.098-1.095 0 0 0 .287.045.547.115.602.431 1.146.897 1.544.113.27.241.534.386.79a.84.84 0 0 1 .099.215c.08.287.27.897.27 1.04 0 .144 0 1.113.17 1.248a.45.45 0 0 0 .43 0l.09-.252.135.135.278-.206a1.059 1.059 0 0 0-.26-.942c-.314-.386-.386-.602-.377-.673a.116.116 0 0 0 0-.054v-.844a.592.592 0 0 0-.081-.233.37.37 0 0 0-.09-.08.116.116 0 0 1-.045-.1 9.25 9.25 0 0 0 .09-1.56s-.054-.108 0-.144c.054-.036.063 0 .09-.045a.816.816 0 0 0 1.014-.072h.305s.466-.26.152-.547v-.153l-.18-.054-.591.7-.314.045-.368-.251a4.164 4.164 0 0 1-.386-1.256 1.237 1.237 0 0 0-.511-.817.7.7 0 0 0-.063-.466.718.718 0 0 0-.126-.162 3.742 3.742 0 0 0-1.04-.682 19.362 19.362 0 0 0-1.867-.664l-.17.153.332 1.588h-.054a6.282 6.282 0 0 0-.844-1.938 2.853 2.853 0 0 0-1.965-.897s0-.458-1.65-.557l-.046-.412h-.376l-.09-.108.323-.287V6.62h-.754s1.23-.78 1.256-1.059a.807.807 0 0 0 0-.413c-.125-.314-.556-.376-1.031-.502A7.322 7.322 0 0 1 8.787 4h-.08v.206l.529.368 1.005.601v.117l-.718.404-.475.188a1.04 1.04 0 0 0-.736-.098 1.095 1.095 0 0 0-.71.592h-.61l-.466.26a.538.538 0 0 1-.18.296.61.61 0 0 1-.268.135h-.216l-.69.152H4.48a1.337 1.337 0 0 1-.421-.063L3.054 6.79 3 6.961Z" fill="#fff"/><path d="M11.632 14.516a3.167 3.167 0 0 0 2.225 1.723c.212.166.371.39.457.646.245.156.439.38.557.646.116.367.448.655.457 1.005a1.8 1.8 0 0 0 .126.61s.466.197.511 0a.458.458 0 0 0 0-.296s.108.17.189.17c.08 0 .404-.108.386-.206a3.586 3.586 0 0 0-.449-.996 7.92 7.92 0 0 0-.897-.96 3.908 3.908 0 0 1-.198-.548 5.023 5.023 0 0 0-.834-1.256l-2.001-.35-.53-.188Z" fill="#fff"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconBullhorn',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
